import { HostFormData, HostFormResponse } from '../types/host';
import { config } from '../config/env';

// Mock API response for development
const mockApiResponse = async (data: HostFormData): Promise<HostFormResponse> => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Log the submission for development
  console.info('Host BTM form submission:', {
    ...data,
    forwardTo: 'support@diversicoin.cash'
  });
  
  return {
    success: true,
    message: 'Application submitted successfully'
  };
};

export async function submitHostForm(data: HostFormData): Promise<HostFormResponse> {
  try {
    // Use mock API in development
    if (import.meta.env.DEV) {
      return await mockApiResponse(data);
    }

    // Real API call for production
    const response = await fetch(config.contactApiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        subject: 'New BTM Host Application',
        forwardTo: 'support@diversicoin.cash'
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to submit application');
    }

    return await response.json();
  } catch (error) {
    console.error('Host form submission error:', error);
    throw new Error('Failed to submit application. Please try again later.');
  }
}